import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getDistrictList = createAsyncThunk(
  "district/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.districts +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
  
    return response.data;
  }
);

export const addDistrict = createAsyncThunk(
  "district/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.districts, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editDistrict = createAsyncThunk(
  "district/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.districts + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getDistrictCount = async () =>{
  const response = await Client(API_METHOD.GET, url.districts)
  return response.data?.data?.item?.total_count;
}

export const getDistrict = createAsyncThunk("district/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.districts + `/${id}`);
  return response.data;
});

